import { ProjectDto } from '@app/generated/model';

export class Project {
  id: string;
  name: string;
  selected?: boolean;

  static fromDto(dto: ProjectDto): Project {
    return {
      id: dto.id,
      name: dto.name,
    };
  }
}
